@let blok = block();
@let isOpen = open();

<button (click)="toggle()"
        class="s1-faq-item--toggle"
        [attr.aria-controls]="id"
        [attr.aria-expanded]="isOpen"
        [class.is-open]="isOpen">
    <span class="s1-faq-item--toggle-title font-bold">
        {{ blok.question }}
    </span>
    <img src="/icons/arrow.svg"
         class="s1-faq-item--toggle-chevron"
         alt=""
         height="24"
         width="24"
         loading="lazy" />
</button>
@if (blok.answers?.length) {
    <div [id]="id"
         [attr.aria-hidden]="!isOpen"
         class="s1-faq-item--content"
         [class.hidden]="!isOpen">
        @for (answer of blok.answers; track answer._uid) {
            @switch (answer.component) {
                @case ("text") {
                    <p class="s1-faq-item--paragraph">
                        {{ answer.text }}
                    </p>
                }
                @default {
                    <s1-cms-component [blok]="answer" />
                }
            }
        }
    </div>
}
